<template>
  <div class="custom-select-wrapper" @click="toggleDropdown" ref="dropdown">
    <div class="selected-option">
      {{ getCurrentLang.text }}
      <svg class="arrow" :class="{ open: showDropdown }" xmlns="http://www.w3.org/2000/svg" xml:space="preserve"
        width="10" height="10" viewBox="0 0 451.847 451.847" fill="#525252">
        <path
          d="M225.923 354.706c-8.098 0-16.195-3.092-22.369-9.263L9.27 151.157c-12.359-12.359-12.359-32.397 0-44.751 12.354-12.354 32.388-12.354 44.748 0l171.905 171.915 171.906-171.909c12.359-12.354 32.391-12.354 44.744 0 12.365 12.354 12.365 32.392 0 44.751L248.292 345.449c-6.177 6.172-14.274 9.257-22.369 9.257z" />
      </svg>
    </div>
    <div class="options-container">
      <ul class="options-list" v-show="showDropdown">
        <li v-for="(item, index) in language" :key="index" @click.stop="selectLang(item)" class="option-item"
          :class="{ selected: item.name === currentLang }">
          {{ item.description }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { store } from '@/store.js'

export default {
  props: ['limited', 'utilityLang'],
  data() {
    return {
      currentLang: store.lang,
      showDropdown: false,
      language: [
        { name: "uk", text: "UA", description: "Українська" },
        { name: "en", text: "EN", description: "English" },
        { name: "tg", text: "TG", description: "Забони тоҷикӣ" },
        { name: "tr", text: "TR", description: "Türkçe" },
        { name: "ar", text: "AR", description: "العربية" },
        { name: "cn", text: "CN", description: "简体中文" },
        { name: "de", text: "DE", description: "Deutsch" },
        { name: "el", text: "EL", description: "Greek" },
        { name: "es", text: "ES", description: "Español" },
        { name: "et", text: "ET", description: "Eesti keel" },
        { name: "fi", text: "FI", description: "Suomi" },
        { name: "fr", text: "FR", description: "Français" },
        { name: "he", text: "HE", description: "עִבְרִית" },
        { name: "it", text: "IT", description: "Italiano" },
        { name: "ka", text: "KA", description: "Georgian" },
        { name: "km", text: "KM", description: "Khmer" },
        { name: "lt", text: "LT", description: "Lietuvių kalba" },
        { name: "lv", text: "LV", description: "Latvian" },
        { name: "pl", text: "PL", description: "Polski" },
        { name: "pt", text: "PT", description: "Português" },
        { name: "ro", text: "RO", description: "Romanian" },
        { name: "ru", text: "RU", description: "Русский" },
        { name: "be", text: "BE", description: "Беларуская мова" }
      ]
    };
  },
  computed: {
    getCurrentLang() {
      return this.language.find(lang => lang.name === this.currentLang) || {};
    }
  },
  created() {
    if (this.limited) {
      this.language = this.limited;
      this.currentLang = this.utilityLang;
    }
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    selectLang(item) {
      this.currentLang = item.name;
      this.$emit('changeLang', this.currentLang);
      this.showDropdown = false;
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdown;
      if (dropdown && !dropdown.contains(event.target)) {
        this.showDropdown = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside); // додаємо глобальний обробник кліку
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside); // видаляємо глобальний обробник кліку
  },
};
</script>
<style scoped>
.custom-select-wrapper {
  position: relative;
  cursor: pointer;
  user-select: none;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}

.selected-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-weight: 500;
}

.arrow {
  /* width: 10px;
  height: 10px; */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.arrow.open {
  transform: rotate(180deg);
}

.options-container {
  overflow: hidden;
  border-radius: 6px;
  position: absolute;
  top: 49px;
  right: 0;
  z-index: 10;
  -webkit-box-shadow: 0 4px 10px rgba(0, 0, 0, .2);
  box-shadow: 0 4px 10px rgba(0, 0, 0, .2);
}

.options-list {
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 6px;
  min-width: 180px;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  list-style-type: none;
  margin: 0;
  padding: 0;
  padding: 0.5rem 0; 
  display: flex;
  flex-flow: column;
  gap: 5px;
}

.options-list::-webkit-scrollbar {
  width: 5px;
  border: 1px solid #c0c0c033;
}

.options-list::-webkit-scrollbar-thumb {
  background-color: #ccc;
}

.options-list::-webkit-scrollbar-thumb:hover {
  background-color: #aaa;
}

.option-item {
  box-sizing: border-box;
  padding: 5px 12px;
  transition: background-color 0.2s;
}

.option-item.selected {
  color: #484848;
  font-weight: bold;
}

.option-item:hover {
  background-color: #007aff;
  color: white;
}
</style>
